import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LeadDetailsSkeleton = () => {
  return (
    <div className="p-4 space-y-6">
      {/* Status Progress Skeleton */}
      <div className="max-w-xl mx-auto space-y-4">
        <Skeleton height={8} className="rounded-full" />
        <div className="flex justify-between">
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} width={60} height={20} />
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left Column - Lead Info */}
        <div className="w-full lg:w-1/3 space-y-4">
          <div className="rounded-xl p-4 bg-white shadow-sm">
            <div className="flex justify-between mb-4">
              <Skeleton width={120} height={24} />
              <Skeleton circle width={24} height={24} />
            </div>

            {/* Basic Info */}
            <div className="space-y-3">
              {[...Array(7)].map((_, i) => (
                <div key={i} className="flex justify-between">
                  <Skeleton width={80} height={16} />
                  <Skeleton width={100} height={16} />
                </div>
              ))}
            </div>

            {/* Address Sections */}
            {[...Array(3)].map((_, i) => (
              <div key={i} className="mt-6">
                <Skeleton width={120} height={20} className="mb-3" />
                <div className="space-y-2">
                  {[...Array(4)].map((_, j) => (
                    <div key={j} className="flex justify-between">
                      <Skeleton width={60} height={14} />
                      <Skeleton width={100} height={14} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column - Tasks */}
        <div className="w-full lg:w-2/3 space-y-6">
          {/* Add Task Section */}
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <Skeleton width={120} height={28} className="mb-6" />
            <div className="space-y-4">
              <Skeleton height={40} />
              <div className="flex items-center gap-2">
                <Skeleton circle width={24} height={24} />
                <Skeleton width={80} height={16} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <Skeleton height={40} />
                <Skeleton height={40} />
              </div>
              <Skeleton height={40} />
            </div>
          </div>

          {/* Ongoing Tasks */}
          <div className="space-y-4">
            <Skeleton width={120} height={24} />
            {[...Array(2)].map((_, i) => (
              <div key={i} className="p-4 bg-white rounded-xl shadow-sm">
                <div className="flex justify-between items-center">
                  <div className="space-y-2">
                    <Skeleton width={150} height={20} />
                    <div className="flex items-center gap-2">
                      <Skeleton width={20} height={20} />
                      <Skeleton width={120} height={16} />
                    </div>
                  </div>
                  <Skeleton width={80} height={32} />
                </div>
              </div>
            ))}
          </div>

          {/* Completed Tasks */}
          <div className="space-y-4">
            <Skeleton width={120} height={24} className="mt-6" />
            {[...Array(2)].map((_, i) => (
              <Skeleton key={i} height={60} className="rounded-xl" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsSkeleton;
